import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { fetchMe } from '../lib/meClient';
import { isPostHogActive, startPostHogForUser } from '../lib/posthogClient';

function capturePageview(posthog: ReturnType<typeof usePostHog>): void {
  posthog.capture('$pageview', { $current_url: window.location.origin + window.location.pathname + window.location.search });
}

/** SPA $pageview for correct paths (default pageview is wrong for client routing). Only while logged in. */
export function PostHogPageviews() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (!isPostHogActive()) return;
    capturePageview(posthog);
  }, [location.pathname, location.search, posthog]);

  return null;
}

/**
 * Starts PostHog and ties recordings/events to the user once /api/me succeeds.
 * Re-checks on navigation so a login without page reload is picked up.
 */
export function PostHogIdentifyUser() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (isPostHogActive()) return;
    let cancelled = false;
    fetchMe()
      .then((data) => {
        if (cancelled || !data?.user?.id || isPostHogActive()) return;
        startPostHogForUser();
        if (!isPostHogActive()) return;
        posthog.identify(data.user.id, {
          email: data.user.email,
          name: data.user.username,
          instance_id: data.activeInstance?.id,
          instance_name: data.activeInstance?.name ?? undefined,
        });
        // The pageview effect ran before PostHog was active; record the current page now.
        capturePageview(posthog);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [location.pathname, posthog]);

  return null;
}
